import React,{ useEffect, useState } from "react";
import './App.css';
import Chat from "./Chat";
import Sidebar from "./Sidebar";
import Pusher from "pusher-js"
import axios from "./axios"

function App() {
  const [messages, setMessages] = useState([])
  useEffect(() => {
    axios.get('/messages/sync').then(response => {
      console.log(response.data)
      setMessages(response.data)
    })
  })

  useEffect(() => {
    const pusher = new Pusher('79f409bd004a2137c701', {
      cluster: 'us2'
    });

    const channel = pusher.subscribe("messages");
    channel.bind("inserted", (newMessage) => {
      alert(JSON.stringify(newMessage));
      setMessages([...messages,newMessage])
    });
   return () => {
      channel.unbind_all();
      channel.unsubscribe();
    }
  },[messages])



  return (
    <div className="app">
    <div className="app__body">
    <Sidebar />
    <Chat messages={ messages }/>
    </div>
    </div>
  );
}

export default App;
